/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */

import styled from 'styled-components';

export const CellSpan = styled.span`
  color: #4948ac;

  &:hover {
    cursor: pointer;

    color: #2dcaff;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%
  padding: 20px;
  background-color: #f4f4f4;
`;

export const PageTitle = styled.h1`
  font-size: 3rem;
  color: #1a1a32;
  font-weight: 600;
  margin-bottom: 20px;
`;

export const ScreenHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Separator = styled.div`
  min-height: 30px;
`;

export const LeftHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const DropdownWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
`;

export const RightHeader = styled.div`
  width: 60%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  max-height: auto;
`;

export const HelpForm = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  width: 100%;
  gap: 0px;
  justify-content: center;
  max-height: auto;
`;

export const RegularText = styled.span`
  font-size: 1.6rem;
`;

export const Input = styled.input`
  padding: 10px;
  font-size: 1.6rem;
  border: 1px solid #ccc;
  border-radius: 4px; /* Rounded corners for input */
  transition: border-color 0.3s;

  &:focus {
    border-color: #007bff; /* Highlight border on focus */
    outline: none; /* Remove default outline */
  }
`;

export const RegularButton = styled.button`
  padding: 10px 20px;
  font-size: 1.6rem;
  color: #fff;
  background-color: #007bff; /* Primary button color */
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 10px;
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  width: 100%;
  background-color: #fff;
  height: 80vh;
`;

export const MileageConfigurationForm = styled.form``;

export const MileageConfigurationHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const MileageConfigurationBody = styled.div`
  padding: 24px;
  border-radius: 20px;
  background: white;
`;

export const MileageConfigurationFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
`;

export const FullWidthField = styled.div`
  grid-column: span 2;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TabContainer = styled.div`
  display: flex;
  gap: 20px;
`;

export const Tab = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 246px;
  height: 45px;
  background: ${({ selected }) =>
    selected ? '#fff 0% 0% no-repeat padding-box' : '#c9cbd3 0% 0% no-repeat padding-box'};
  border-radius: 4px 4px 0px 0px;
  font: normal normal normal 16px/24px Biotif;
  font-weight: 600;
  cursor: pointer;
`;

export const TabTitle = styled.div`
  font-size: 14px;
  text-transform: capitalize;
`;

export const CompanyHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const CompanyContainer = styled.div`
  margin-left: 20px;
  width: 95%;
`;
